import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  name: 'ed-class-builder-placeholders-modal',
  components: {},
})
export default class EdClassBuilderPlaceholderModal extends Vue {
  @Prop({ default: null }) readonly params: any;

  displayPlaceholders = [];

  get isAbleToEdit(): boolean {
    return this.params.isAbleToEdit;
  }

  emitUnrelatePlaceholder(placeholderId) {
    this.params.emitUnrelatePlaceholder(placeholderId);
    this.displayPlaceholders = this.displayPlaceholders.filter(el => el.placeholder.id !== placeholderId);
  }

  lightOrDark(color) { 
    return this.params.lightOrDark(color);
  }

  closePlaceholders() {
    this.$EdModal.closeModal();
  }

  mounted () {
    this.displayPlaceholders = this.params.placeholders;
  }
}
